import React from 'react';
import { FieldGroup } from "./FieldGroup";
import {connect} from "react-redux";
import {removeSubField} from "../../../../store/actions/subFields";
import {changeGroupField} from "../../../../store/actions/groupFields";
import {FieldGroupContext} from "../../../../contexts/FieldGroupContext";

const FieldGroups = (props) => {

	const { removeSubField, group, changeGroupField } = props;

  function updateFieldGroupOrderFoward(groups, currentIndex, action, endpointId) {
    const nextFieldGroup = groups[currentIndex + 1];

    if (!nextFieldGroup) {
      return;
    }

    const nextFieldIndex = groups[currentIndex + 1].order;

    changeGroupField(endpointId, group, currentIndex, 'order', nextFieldIndex, action);
    changeGroupField(endpointId, group, nextFieldIndex, 'order', currentIndex, action);
  }

  function updateFieldGroupOrderBackward(groups, currentIndex, action, endpointId) {
    const prevFieldGroup = groups[currentIndex - 1];

    if (!prevFieldGroup) {
      return;
    }

    const prevFieldIndex = groups[currentIndex - 1].order;

    changeGroupField(endpointId, group, currentIndex, 'order', prevFieldIndex, action);
    changeGroupField(endpointId, group, prevFieldIndex, 'order', currentIndex, action);
  }

	return (
		<FieldGroupContext.Consumer>

			{({ endpointId, currentItem, action }) => (

				<React.Fragment>
          <div className="field-group-wrap">
            {
              props.endpoints[endpointId][action][currentItem][group]
                .sort((a, b) => a.order - b.order)
                .map((el, index) => <React.Fragment key={index}>
              <div className={el.collapsed ? 'RestRoutesFieldGroup field-group-collapsed' : 'RestRoutesFieldGroup'}>
                <span
                  className="dashicons dashicons-fullscreen-alt collapse-button"
                  onClick={
                    () => changeGroupField(endpointId, group, index, 'collapsed', !el.collapsed, action)
                  }
                />

                {group === 'output'
                  ?
                  <React.Fragment>
                    <span
                      className="dashicons dashicons-arrow-right-alt2 move-field-group"
                      onClick={
                        () => updateFieldGroupOrderFoward(
                          props.endpoints[endpointId][action][currentItem][group],
                          index,
                          action,
                          endpointId
                        )
                      }
                    />
                    <span
                      className="dashicons dashicons-arrow-left-alt2 move-field-group"
                      onClick={
                        () => updateFieldGroupOrderBackward(
                          props.endpoints[endpointId][action][currentItem][group],
                          index,
                          action,
                          endpointId
                        )
                      }
                    />
                  </React.Fragment>
                  : ''
                }
                <FieldGroup key={index} label={el.label} fields={el.fields} group={group} groupId={index} currentItem={currentItem} action={action}/>
                { ( props.renderRemoveField || typeof props.renderRemoveField === 'undefined' && ( typeof el.renderRemoveField === 'undefined') ) && <button className="button-secondary" onClick={() => removeSubField(endpointId, index, group, currentItem, action)}>Remove</button> }
              </div>
            </React.Fragment>)}
          </div>
				</React.Fragment>

			)}

		</FieldGroupContext.Consumer>
	);
};

const mapStateToProps = ( state, props ) => ({
	renderRemoveField: props.renderRemoveField,
	endpoints: state.settings.endpoints
});

const mapDispatchToProps = dispatch => ({
	removeSubField: ( endpointId, index, group, currentItem, action ) => dispatch( removeSubField( endpointId, index, group, currentItem, action ) ),
  changeGroupField: (
    endpointId,
    group,
    index,
    field,
    value,
    action ) => dispatch(
    changeGroupField(
      endpointId,
      group,
      index,
      field,
      value,
      action
    )
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(FieldGroups);
